import React from "react"
import { useDispatch } from "react-redux"
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap"
import AttendanceAction from "store/attendance-resource/actions"

const ModalLeavingWork = ({ setIsModal, isModal, validation, setIsUpdate }) => {
  const dispatch = useDispatch()
  const toggle = () => setIsModal(!isModal)

  return (
    <Modal isOpen={isModal} toggle={toggle} centered>
      <ModalHeader className="text-center" toggle={toggle}>
        注意
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col sm={12} className="text-center">
            本日合計作業時間が８時間未満ですが、 退勤しますか？
          </Col>

          <div className="text-center mt-3">
            <Button
              className="me-2"
              color="danger"
              onClick={() => {
                try {
                  dispatch(AttendanceAction.postClockOut(validation.values))
                  setIsUpdate(true)
                  setIsModal(false)
                } catch (error) {
                  console.log(error)
                }
              }}
            >
              はい
            </Button>
            <Button className="ms-2" onClick={() => setIsModal(false)}>
              いいえ
            </Button>
          </div>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default ModalLeavingWork
